import type { CSSProperties } from 'react';

export function SecretaryGeneral({ className = '', style }: { className?: string; style?: CSSProperties }) {
  return <div className={`guardian secretary-general ${className}`.trim()} style={style}>
    <div className="guardian-head">
      <img className="secretary-general-face" src="/brand/secretary-general-face.png" alt="" draggable={false} />
      <i className="secretary-mouth-motion" />
    </div>
    <i className="arm left" />
    <i className="arm right" />
    <div className="guardian-body" />
  </div>;
}
